import { DropDownEntry } from '../custom-inputs/wizard-drop-down/drop-down-entry.model'
import { EntityReference } from '../../dto'
import { Address } from '../../../models/address'

export let DROP_DOWN = 'DropDown'
export let STRING_INPUT = 'StringInput'
export let DATE_INPUT = 'DateInput'
export let BOOLEAN_INPUT = 'BooleanInput'
export let FLOAT_INPUT = 'FloatInput'
export let INTEGER_INPUT = 'IntegerInput'
export let REFERENCE = 'Reference'
export let LABEL = 'Label'
export let CURRENCY_INPUT = 'CurrencyInput'
export let ADDRESS_INPUT = 'AddressInput'
export const MULTILINE_INPUT = 'MultilineInput'
export const GRID_INPUT = 'GridInput'
export const PROGRESS = 'Progress'
export const LOG = 'Log'

export interface GridColumn {
  type: 'String' | 'int' | 'float' | 'boolean' | 'date' | 'testType'
  field: string
  header: string
  width: number | undefined
}

export let PUSH_UPDATE = 'PushUpdate'

export enum WIZARD_TYPE {
  CREATE_DTO = 'CREATE_DTO',
  UPDATE_DTO = 'UPDATE_DTO'
}

export type WizardAction =
  | {
      type: 'LAYOUT'
      title: string
      width: string
      fields: WizardLayoutItem[]
      buttons: WizardButton[]
    }
  | {
      type: 'CLOSE'
    }
  | {
      type: 'MESSAGE'
      message: string
      messageType: string
      delayInMS?: number
    }
  | {
      type: 'UPDATE_FIELD'
      field: string
      value: any
    }
  | {
      type: 'OPEN_ENTITY_DIALOG'
      contextId: string
      dtoType: string
      header: string
    }
  | {
      type: 'EXECUTE_ACTION'
      actionHrid: string
      dtoType: string
      entityId: number
    }
  | {
      type: 'EXECUTE_WIZARD'
      context: any
      dtoType: string
      wizardId: string
      wizardExecutorId: string
      entityId: number
    }

export class WizardNotification {
  id: string
  actions: WizardAction[]
}

export class WizardLayout {
  fields: WizardLayoutItem[]
  focus: string
}

export type ButtonAlignment = 'LEFT' | 'RIGHT'

export class WizardButton {
  id: string
  label: string
  icon: string
  disabled: boolean
  alignment: ButtonAlignment
  hotkey: string
}

export class ItemButton {
  id: string
  label: string
  icon: string
}

export type OnModify = 'PushUpdate'

export type WizardLayoutItem =
  | {
      type: 'DropDown'
      header: string
      field: string
      mandatory: boolean
      onModify?: OnModify

      value: number
      hideLabel: boolean
      hideIcon: boolean
      hideAbbr: boolean
      hideTooltip: boolean
      entries: DropDownEntry[]
      decimals: number // TODO: properly implement types (string, dropdown, float, integer, ....)
      button: ItemButton | undefined
    }
  | {
      type: 'StringInput'
      header: string
      field: string
      mandatory: boolean
      onModify?: OnModify
      value: string
      button: ItemButton | undefined
    }
  | {
      type: 'DateInput'
      header: string
      field: string
      mandatory: boolean
      value: string | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'FloatInput'
      header: string
      field: string
      mandatory: boolean
      value: number | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'BooleanInput'
      header: string
      field: string
      mandatory: boolean
      onModify: OnModify | undefined
      value: boolean
      button: ItemButton | undefined
    }
  | {
      type: 'IntegerInput'
      header: string
      field: string
      mandatory: boolean
      value: number | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'Reference'
      header: string
      field: string
      mandatory: boolean
      dtoType: string
      referenceFilter: string
      referenceSoftFilter: string
      value: EntityReference | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'Label'
      field: string
      value: string
      buttonId: string | undefined
      buttonIcon: string | undefined
      buttonTooltip: string | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'Currency'
      field: string
      header: string
      value: string
      buttonId: string | undefined
      buttonIcon: string | undefined
      buttonTooltip: string | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'AddressInput'
      header: string
      field: string
      mandatory: boolean
      value: Address | undefined
      onModify: OnModify | undefined
      button: ItemButton | undefined
    }
  | {
      type: 'MultilineInput'
      header: string
      field: string
      mandatory: boolean
      onModify?: OnModify
      value: string
      height: number
      button: ItemButton | undefined
    }
  | {
      type: 'GridInput'
      header: string
      field: string
      mandatory: boolean
      onModify?: OnModify
      value: any[][]
      columns: GridColumn[]
      options?: any
    }
  | {
      type: 'Progress'
      field: string
      value: number
      onModify?: OnModify
      buttonId: string | undefined
      buttonIcon: string | undefined
      buttonTooltip: string | undefined
    }
  | {
      type: 'Log'
      field: string
      value: string
      height: number
      onModify?: OnModify
      buttonId: string | undefined
      buttonIcon: string | undefined
      buttonTooltip: string | undefined
    }

// function test() {
//   let a: WizardLayoutItem;
//   a = {
//     type: 'StringInput',
//     header: 'A',
//     field: 'f',
//     mandatory: true,
//     value: 5
//   };
// }
